import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import InputFilePreview from "../../molecules/InputFilePreview";
import styled from "styled-components";
import InputAddField from "../../molecules/InputAddField";
import InputGroupValidation from "../../molecules/InputGroupValidation";
import MobileAuth from "../../molecules/MobileAuth";
import BranchForm from "../../organisms/BranchForm";
import { hideConfirm, showConfirm } from "../../../../reducer/confirmSlice";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { showAlert } from "../../../../reducer/alertSlice";
import axios from "axios";
import { useRefresh } from "../../../common/hook";

const Wrap = styled.div`
    .form-label {
        width: 150px;

        & + div[class^=col] {
            flex: 1 1;
        }
    }

    .form-check-label {
        white-space: nowrap;
        font-size: 14px;
    }

    .input-group {
        max-width: 500px;
        min-height: 45px;
        align-items: center;
    }
`;
export default function AddCompany(props) {
    const [step, setStep] = useState(0);
    const form = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const refresh = useRefresh();

    // 업체 관리자 리스트
    const [companyAdminList, setCompanyAdminList] = useState([]);
    // 다음 버튼 비활성화 여부
    const [disableNextBtn, setDisableNextBtn] = useState(true);
    const [branchData, setBranchData] = useState({});

    const onSubmit = form.handleSubmit((data) => {
        if (companyAdminList.length == 0) {
            dispatch(showAlert({
                msg: "업체 관리자는 최소 1개 이상의 계정은 필수로 등록해야합니다."
            }))
            return;
        }

        addCompanyMutation.mutate(data);
    });

    const addCompanyMutation = useMutation({
        mutationKey: ['addCompany'],
        mutationFn: (data) => {
            const values = form.getValues();

            return axios("/company/add", {
                method: "POST",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: {
                    companyName: values.companyName,
                    appId: values.appId,
                    merchantId: values.merchantId,
                    branchName: values.branchName,
                    storeId: values.storeId,
                    ownerName: values.ownerName,
                    tel: values.branchTelArea + "-" + values.telNum,
                    registrationNo: values.registrationNo,
                    region: values.region,
                    address: values.address,
                    useIp: values.useIp,
                    ipList: values.ipList,
                    companyAdminList: values.companyAdminList,
                    branchAdminList: values.branchAdminList,
                    generalAdminList: values.generalAdminList,
                    logoFile: values.logoFile.length > 0 ? values.logoFile[0] : "",
                    registrationFile: values.registrationFile.length > 0 ? values.registrationFile[0] : "",
                    contractFile: values.contractFile.length > 0 ? values.contractFile[0] : "",
                }
            }).then(result => {
                if (result.status == "201") {
                    
                    dispatch(showAlert({
                        msg: "등록되었습니다.",
                        func: () => {
                            navigate(-1);
                            refresh.refetch();
                        }
                    }))
                } else {
                    dispatch(showAlert({
                        msg: <>요청을 처리하지 못했습니다. <br/>ERROR STATUS: {result.status}</>,
                    }))
                }
                
                return result;
            }).catch(e => {
                console.log(e);
                
                dispatch(showAlert({
                    msg: <>요청을 처리하지 못했습니다. <br/>ERROR CODE: {e.response.data.code}</>,
                }))
            })
        }
    });

    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        form.setValue("companyAdminList", companyAdminList);
    },[companyAdminList]);

    useEffect(() => {
        const subscription = form.watch((formValue) => {
            setDirty(true);
            setBranchData({
                ...branchData,
                companyName: formValue.companyName
            })
            if (!formValue.companyName || !formValue.appId || !formValue.merchantId || formValue.logoFile.length == 0 || formValue.companyAdminList.length == 0) {
                setDisableNextBtn(true);
            } else {
                setDisableNextBtn(false);
            }
        });
        return () => subscription.unsubscribe();
    },[form.watch]);

    return (
        <Wrap>
            <PageTemplate.Top>
                <div className="d-flex justify-content-between">
                    <div>
                        <BreadCrumb arr={[<Link to="/admin/list/company">관리자 설정</Link>, <Link to="/admin/list/company">업체 관리</Link>, <span className="fw-bold">신규 등록</span>]} />
                        <h1 className="page-title">신규 등록</h1>
                    </div>

                    <ul className="step step-sm step-icon-xs my-3 w-50">
                        <li className="step-item">
                                <div className="step-content-wrapper">
                                <span className={step == 0 ? "step-icon step-icon-primary" : "step-icon step-icon-soft-primary"}>1</span>
                                <div className="step-content">
                                    <span className={step == 0 ? "step-title fs-6" : "step-title text-secondary fs-6"}>업체 등록</span>
                                </div>
                            </div>
                        </li>
                        <li className="step-item">
                            <div className="step-content-wrapper">
                                <span className={step == 1 ? "step-icon step-icon-primary" : "step-icon step-icon-soft-primary"}>2</span>
                                <div className="step-content">
                                    <span className={step == 1 ? "step-title fs-6" : "step-title text-secondary fs-6"}>지점 등록</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </PageTemplate.Top>

            <PageTemplate.Content>
                <div>
                    <div className={step == 0 ? "" : "d-none"}>
                        <Card className="mt-4 overflow-hidden">
                            <Card.Header>
                                <Card.Title className="fs-3 d-flex align-items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
                                    <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z"/>
                                    </svg>
                                    업체 정보
                                </Card.Title>
                            </Card.Header>

                            <Card.Body>
                                <Form.Group as={Row} className="mb-3" controlId="formCompanyName">
                                    <Form.Label column sm="2">
                                        업체명 *
                                    </Form.Label>
                                    <Col sm="8">
                                        <InputGroupValidation 
                                            register={form.register("companyName", {
                                                required: "업체명을 입력해주세요",
                                            })} 
                                            invalid={form.formState.errors['companyName']}
                                            placeholder="업체명을 입력하세요" 
                                            withoutSc={true}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPosition">
                                    <Form.Label column sm="2">
                                        App ID *
                                    </Form.Label>
                                    <Col sm="8">
                                        <InputGroupValidation 
                                            register={form.register("appId", {
                                                required: "App ID를 입력해주세요",
                                            })} 
                                            invalid={form.formState.errors['appId']}
                                            placeholder="App ID를 입력하세요" 
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPosition">
                                    <Form.Label column sm="2">
                                        Merchant ID *
                                    </Form.Label>
                                    <Col sm="8">
                                        <InputGroupValidation 
                                            register={form.register("merchantId", {
                                                required: "App ID를 입력해주세요",
                                            })} 
                                            invalid={form.formState.errors['merchantId']}
                                            placeholder="Merchant ID를 입력하세요" 
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formName">
                                    <Form.Label column sm="2">
                                        로고 이미지 *
                                    </Form.Label>
                                    <Col sm="8">
                                        <InputFilePreview register={form.register("logoFile", {
                                            required: "이미지를 선택해주세요"
                                        })} 
                                        invalid={form.formState.errors['logoFile']} 
                                        max={2}
                                        accept="image/jpg, image/png, image/jpeg" />
                                    </Col>
                                </Form.Group>
                            </Card.Body>
                        </Card>

                        <Card className="mt-4 overflow-hidden">
                            <Card.Header>
                                <Card.Title className="d-flex align-items-center gap-2 fs-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                                    <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                                    </svg>
                                    업체 관리자
                                    <span className="ms-2 fs-6 fw-normal text-danger">* 최소 1개 이상의 계정은 필수로 등록해야합니다.</span>
                                </Card.Title>
                            </Card.Header>

                            <Card.Body>
                                <Form.Group as={Row} className="mb-3" controlId="formPhone">
                                    <Form.Label column sm="2">
                                        휴대폰 번호(ID) *
                                    </Form.Label>
                                    <Col>
                                        <InputAddField btnText="계정 추가" 
                                        template={
                                            <MobileAuth
                                                type="2"
                                                addValue={(value) => {setCompanyAdminList(prev => [...prev, value])}}
                                                removeValue={(value) => {
                                                    setCompanyAdminList(prev => prev.filter(val => value !== val))
                                                }}
                                            />
                                        }
                                        handleDelete={(value) => {
                                            setCompanyAdminList(prev => prev.filter(val => value !== val))
                                        }}></InputAddField>
                                    </Col>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className={step == 1 ? "" : "d-none"}>
                        <BranchForm form={form} defaultData={branchData} isAddCompany={true} />
                    </div>
                </div>
            </PageTemplate.Content>

            <PageTemplate.ButtonContainer className="mt-3">
                <div className={step == 0 ? "" : "d-none"}>
                    <Button type="button" className="me-2" variant="outline-secondary" onClick={() => {
                        if (dirty) {
                            dispatch(showConfirm({
                                msg: <>작성 중인 내용이 저장되지 않았습니다.<br/>정말 나가시겠어요?</>,
                                btnText: "확인",
                                func: () => {
                                    navigate(-1);
                                    dispatch(hideConfirm());
                                }
                            }))
                        } else {
                            navigate(-1);
                        }
                    }}>취소</Button>
                    <Button variant="primary" disabled={disableNextBtn} onClick={() => {setStep(1)}}>다음</Button>
                </div>
                <div className={step == 1 ? "" : "d-none"}>
                    <Button className="me-2" variant="outline-secondary" onClick={() => {setStep(0);}}>이전</Button>
                    <Button variant="primary" onClick={()=>{
                        onSubmit()
                    }}>완료</Button>
                </div>
            </PageTemplate.ButtonContainer>
        </Wrap>
    );
}
